var map = {
	"./Icon-feather-arrow-right.svg": [
		47650,
		7650
	],
	"./admin.svg": [
		23759,
		3759
	],
	"./arrow-down.svg": [
		24746,
		4746
	],
	"./arrow-left.svg": [
		81833,
		1833
	],
	"./arrow-right-bold.svg": [
		16158,
		6158
	],
	"./arrow-right-circle-new.svg": [
		70516,
		516
	],
	"./arrow-right-new.svg": [
		14317,
		4317
	],
	"./arrow-right.svg": [
		80153,
		153
	],
	"./attachment-new.svg": [
		54074,
		4074
	],
	"./attachment.svg": [
		14689,
		4689
	],
	"./attendance_absent.svg": [
		13470,
		3470
	],
	"./attendance_exempt.svg": [
		5428,
		5428
	],
	"./attendance_late.svg": [
		55711,
		5711
	],
	"./attendance_remark.svg": [
		13885,
		3885
	],
	"./awesome-facebook.svg": [
		73224,
		3224
	],
	"./bars-blue.svg": [
		96199,
		6199
	],
	"./bell-lightblue.svg": [
		49870,
		9870
	],
	"./bell.svg": [
		24565,
		4565
	],
	"./book-active.svg": [
		30991,
		991
	],
	"./book-blue.svg": [
		38129,
		8129
	],
	"./book-small.svg": [
		91816,
		731
	],
	"./book.svg": [
		96004,
		6004
	],
	"./calendar-new.svg": [
		91001,
		1001
	],
	"./calendar.svg": [
		90874,
		874
	],
	"./caret-down-new.svg": [
		2988,
		2988
	],
	"./chat-active.svg": [
		64846,
		4846
	],
	"./chat-blue.svg": [
		38833,
		8833
	],
	"./chat-lightblue.svg": [
		12218,
		2218
	],
	"./chat.svg": [
		15166,
		5166
	],
	"./checked.svg": [
		12173,
		2173
	],
	"./chevron-down.svg": [
		51728,
		1728
	],
	"./chevron-thin-left.svg": [
		33320,
		3320
	],
	"./chevron.svg": [
		75964,
		5964
	],
	"./circle.svg": [
		12389,
		2389
	],
	"./classes/anatomy.svg": [
		91799,
		1799
	],
	"./classes/anatomy2.svg": [
		49002,
		9002
	],
	"./classes/art.svg": [
		62861,
		2861
	],
	"./classes/chemistry.svg": [
		98925,
		8925
	],
	"./classes/economy.svg": [
		76769,
		6769
	],
	"./classes/geography.svg": [
		9059,
		9059
	],
	"./classes/history.svg": [
		62023,
		2023
	],
	"./classes/it.svg": [
		80538,
		538
	],
	"./classes/lang_english.svg": [
		31783,
		1783
	],
	"./classes/lang_estonian.svg": [
		42199,
		2199
	],
	"./classes/lang_finnish.svg": [
		14808,
		4808
	],
	"./classes/lang_french.svg": [
		81886,
		1886
	],
	"./classes/lang_german.svg": [
		67049,
		7049
	],
	"./classes/lang_russian.svg": [
		29379,
		9379
	],
	"./classes/lang_spanish.svg": [
		5900,
		5900
	],
	"./classes/literature.svg": [
		3557,
		3557
	],
	"./classes/math.svg": [
		13662,
		3662
	],
	"./classes/music.svg": [
		18478,
		8478
	],
	"./classes/occupational_guidance.svg": [
		46844,
		6844
	],
	"./classes/philosophy.svg": [
		30792,
		792
	],
	"./classes/physics.svg": [
		50184,
		184
	],
	"./classes/psychology.svg": [
		34524,
		4524
	],
	"./classes/science.svg": [
		73910,
		3910
	],
	"./classes/society.svg": [
		77865,
		7865
	],
	"./classes/sports.svg": [
		20364,
		364
	],
	"./clock-active.svg": [
		67349,
		7349
	],
	"./clock-passive.svg": [
		76205,
		6205
	],
	"./clock.svg": [
		5997,
		5997
	],
	"./close-green.svg": [
		18319,
		8319
	],
	"./close-icon-non-circle.svg": [
		89511,
		9511
	],
	"./close-icon.svg": [
		83997,
		3997
	],
	"./close-new.svg": [
		66646,
		6646
	],
	"./closed-book.svg": [
		59877,
		9877
	],
	"./comment-new.svg": [
		21837,
		1837
	],
	"./comment.svg": [
		45184,
		5184
	],
	"./copy-icon.svg": [
		61709,
		110
	],
	"./corner-up-left.svg": [
		85924,
		5924
	],
	"./dash-active.svg": [
		61241,
		1241
	],
	"./dash-blue.svg": [
		86970,
		6970
	],
	"./dash.svg": [
		46875,
		6875
	],
	"./datepicker-new.svg": [
		51361,
		1361
	],
	"./delete.svg": [
		82539,
		2539
	],
	"./discussion.svg": [
		83968,
		3968
	],
	"./down-arrow.svg": [
		51481,
		1481
	],
	"./edit-pen.svg": [
		95949,
		5949
	],
	"./edit.svg": [
		98377,
		8377
	],
	"./emoji.svg": [
		95002,
		5002
	],
	"./expand.svg": [
		20951,
		951
	],
	"./export.svg": [
		46707,
		6707
	],
	"./eye.svg": [
		45564,
		5564
	],
	"./eyeClosed.svg": [
		43379,
		3379
	],
	"./failed.svg": [
		29061,
		9061
	],
	"./feather-arrow-down.svg": [
		64691,
		4691
	],
	"./file-plus.svg": [
		7061,
		7061
	],
	"./file-text.svg": [
		76963,
		6963
	],
	"./filter-list.svg": [
		4215,
		4215
	],
	"./floppy-new.svg": [
		74490,
		4490
	],
	"./full-screen.svg": [
		72726,
		2726
	],
	"./general-36/book.svg": [
		25380,
		5380
	],
	"./general-36/favorite-plus.svg": [
		91615,
		1615
	],
	"./general-36/fitness.svg": [
		88230,
		8230
	],
	"./general-36/note.svg": [
		10460,
		460
	],
	"./general-36/video.svg": [
		23015,
		3015
	],
	"./grades-active.svg": [
		31154,
		1154
	],
	"./grades-blue.svg": [
		60813,
		813
	],
	"./grades.svg": [
		87000,
		7000
	],
	"./hand.svg": [
		28187,
		8187
	],
	"./header/calendar.svg": [
		56179,
		6179
	],
	"./header/grades.svg": [
		79611,
		9611
	],
	"./header/latest-activites.svg": [
		20106,
		106
	],
	"./header/latest-chats.svg": [
		70360,
		360
	],
	"./header/my-tasks.svg": [
		92358,
		2358
	],
	"./header/subject-chapters.svg": [
		44154,
		4154
	],
	"./header/upcoming.svg": [
		63889,
		3889
	],
	"./hide-password.svg": [
		1291,
		1291
	],
	"./homework.svg": [
		12231,
		2231
	],
	"./icon-edit.svg": [
		28423,
		8423
	],
	"./icons8-google.svg": [
		66762,
		6762
	],
	"./info-active.svg": [
		77075,
		7075
	],
	"./info-icon-small.svg": [
		48666,
		8666
	],
	"./info.svg": [
		67292,
		7292
	],
	"./information.svg": [
		64882,
		4882
	],
	"./like-op.svg": [
		42903,
		2903
	],
	"./like.svg": [
		40685,
		685
	],
	"./list-blue.svg": [
		70651,
		651
	],
	"./list.svg": [
		57380,
		7380
	],
	"./live-class-active.svg": [
		55921,
		5921
	],
	"./live-class-blue.svg": [
		13558,
		3558
	],
	"./live-class.svg": [
		13970,
		3970
	],
	"./members-white.svg": [
		80509,
		509
	],
	"./members.svg": [
		48327,
		8327
	],
	"./menu/alert-reminder.svg": [
		79332,
		9332
	],
	"./menu/alert.svg": [
		32803,
		2803
	],
	"./menu/arrow-right.svg": [
		20724,
		724
	],
	"./menu/attach.svg": [
		61381,
		1381
	],
	"./menu/camera.svg": [
		53412,
		3412
	],
	"./menu/check.svg": [
		83727,
		3727
	],
	"./menu/close.svg": [
		99386,
		9386
	],
	"./menu/comment.svg": [
		31450,
		1450
	],
	"./menu/copy.svg": [
		12343,
		2343
	],
	"./menu/delete.svg": [
		89461,
		9461
	],
	"./menu/edit.svg": [
		64470,
		4470
	],
	"./menu/emoticons.svg": [
		36282,
		6282
	],
	"./menu/favorite-plus.svg": [
		17469,
		7469
	],
	"./menu/favourite.svg": [
		24736,
		4736
	],
	"./menu/hide.svg": [
		52011,
		2011
	],
	"./menu/info.svg": [
		71692,
		1692
	],
	"./menu/language.svg": [
		83619,
		3619
	],
	"./menu/layers.svg": [
		24820,
		4820
	],
	"./menu/like.svg": [
		41674,
		1674
	],
	"./menu/link.svg": [
		7171,
		7171
	],
	"./menu/maximise.svg": [
		8772,
		8772
	],
	"./menu/minimise.svg": [
		90374,
		374
	],
	"./menu/pin.svg": [
		31257,
		1257
	],
	"./menu/profile.svg": [
		42346,
		2346
	],
	"./menu/search.svg": [
		50399,
		399
	],
	"./menu/signout-rtl.svg": [
		20718,
		718
	],
	"./menu/signout.svg": [
		40544,
		544
	],
	"./menu/users.svg": [
		10051,
		51
	],
	"./menu/view.svg": [
		94599,
		4599
	],
	"./message-circle.svg": [
		30271,
		271
	],
	"./message-square.svg": [
		51373,
		5
	],
	"./minimize-drawer.svg": [
		81696,
		1696
	],
	"./minimze.svg": [
		58519,
		8519
	],
	"./minus.svg": [
		4475,
		4475
	],
	"./more-vertical.svg": [
		48082,
		8082
	],
	"./options.svg": [
		69994,
		9994
	],
	"./pencil.svg": [
		61265,
		1265
	],
	"./percentage.svg": [
		22009,
		2009
	],
	"./pinn-black.svg": [
		74982,
		4982
	],
	"./pinn-white.svg": [
		82286,
		2286
	],
	"./pinn.svg": [
		83144,
		3144
	],
	"./play-circle.svg": [
		48578,
		8578
	],
	"./play.svg": [
		5590,
		5590
	],
	"./plus-blue.svg": [
		99850,
		9850
	],
	"./plus-circle.svg": [
		45304,
		5304
	],
	"./plus.svg": [
		23189,
		3189
	],
	"./plus_green.svg": [
		95010,
		5010
	],
	"./plus_w.svg": [
		33624,
		3624
	],
	"./quiz-icon-blue-noplus.svg": [
		45456,
		5456
	],
	"./quiz-icon-blue-small.svg": [
		28950,
		8950
	],
	"./quiz-icon-blue.svg": [
		27291,
		7291
	],
	"./quiz-icon-green.svg": [
		29426,
		9426
	],
	"./quiz-plus.svg": [
		13449,
		3449
	],
	"./quotes.svg": [
		24215,
		6464
	],
	"./refresh.svg": [
		39525,
		9525
	],
	"./save.svg": [
		53884,
		3884
	],
	"./search-lightblue.svg": [
		16783,
		6783
	],
	"./search-white.svg": [
		54478,
		4478
	],
	"./search.svg": [
		79262,
		9262
	],
	"./send.svg": [
		89459,
		9459
	],
	"./show-password.svg": [
		13073,
		3073
	],
	"./small-arrow.svg": [
		35031,
		5031
	],
	"./small-logo-header-mobile.svg": [
		71410,
		1410
	],
	"./star.svg": [
		3740,
		3740
	],
	"./stop-circle.svg": [
		90310,
		310
	],
	"./subject.svg": [
		29012,
		9012
	],
	"./task/task-book.svg": [
		28387,
		8387
	],
	"./task/task-info.svg": [
		68370,
		8370
	],
	"./task/task-quiz.svg": [
		80480,
		480
	],
	"./task/task-video.svg": [
		95086,
		5086
	],
	"./tests.svg": [
		46377,
		6377
	],
	"./thumbs-up.svg": [
		67515,
		7515
	],
	"./trash-2.svg": [
		68725,
		8725
	],
	"./trash-can.svg": [
		20536,
		536
	],
	"./trash.svg": [
		10967,
		967
	],
	"./trashIcon.svg": [
		70052,
		52
	],
	"./unpin.svg": [
		55665,
		5665
	],
	"./upload.svg": [
		10377,
		377
	],
	"./user.svg": [
		51816,
		1816
	],
	"./userGroup.svg": [
		35582,
		5582
	],
	"./x.svg": [
		74118,
		4118
	],
	"./xmark-blue.svg": [
		21782,
		1782
	],
	"./youtube.svg": [
		44925,
		4925
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 62873;
module.exports = webpackAsyncContext;